import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { clearStoredAuth, ensureValidSession, getAuthState, resolveAdminAccess, verifyAdminAccess } from '../utils/auth';

export default function AdminRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let cancelled = false;

    setStatus('checking');

    ensureValidSession().then((sessionResult) => {
      if (cancelled) {
        return;
      }

      if (!sessionResult?.ok) {
        clearStoredAuth();
        setStatus('unauthenticated');
        return;
      }

      const authState = getAuthState();

      verifyAdminAccess(sessionResult.token).then((result) => {
        if (cancelled) {
          return;
        }

        const nextStatus = resolveAdminAccess(authState, result);
        if (nextStatus === 'unauthenticated') {
          clearStoredAuth();
        }
        setStatus(nextStatus);
      });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (status === 'forbidden') {
    return <Navigate to="/dashboard" replace />;
  }

  if (status !== 'authorized') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem' }}>
        <p>Verificando permisos de administrador...</p>
      </div>
    );
  }

  return children;
}